import {gsap} from "gsap";
import { selectMatchingVideoSource } from '../utils';

export default class HomeTrailer {
    constructor(elm) {

        this.breakpoint = window.matchMedia('(max-width:991px)');

        this.homeTrailer = elm;
        this.videoModal = this.homeTrailer.querySelector('[data-video-modal]');

        if(this.videoModal) {
            this.openModalButton = this.homeTrailer.querySelector('[data-open-modal-button]');
            this.videoModalInner = this.videoModal.querySelector('[data-video-modal-inner]');
            this.video = this.videoModal.querySelector('video');

            this.resizeObserver = new ResizeObserver(this.handleResize.bind(this));
            this.resizeObserver.observe(this.video);

            this.playButton = this.videoModal.querySelector('[data-play-button]');
            this.pauseButton = this.videoModal.querySelector('[data-pause-button]');
            this.closeModalButton = this.videoModal.querySelector('[data-close-modal-button]');

            this.video.addEventListener('ended', () => {
                this.closeModal();
            });

            this.video.addEventListener('playing', () => {
                this.onPlaying();
            });

            this.video.addEventListener('pause', () => {
                this.onPause();
            });

            this.modalOpen = false;

            if (this.openModalButton) {
                this.openModalButton.addEventListener('click', () => {
                    this.toggleModal();
                });
            }

            if (this.videoModalInner) {
                this.videoModalInner.addEventListener('click', () => {
                    if (this.video) {
                        if (this.video.paused) {
                            this.playVideo();
                        } else {
                            this.pauseVideo();
                        }
                    }
                });
            }

            if (this.closeModalButton) {
                this.closeModalButton.addEventListener('click', () => {
                    this.toggleModal();
                });
            }
        }

        this.canHoverAndPoint = window.matchMedia('(hover: hover) and (pointer: fine)');

        this.init();
    }


    init() {
        this.openModalButton.classList.add('is-visible');

        this.boundHandleKeys = this.handleKeys.bind(this);
        document.addEventListener('keydown', this.boundHandleKeys);

    }

    handleKeys(e) {
        if (e.key === 'Enter') {
			this.openModal();
		}
		if (e.key === 'Escape') {
			this.closeModal();
		}
	}

    handleResize(entries) {
		entries.forEach(entry => {
            selectMatchingVideoSource(entry.target);
		});
	}

    playVideo() {
        this.playButton.classList.add('is-visible');
        this.video.play();
    }

    onPlaying() {
        this.playButton.classList.remove('is-visible');
        this.pauseButton.classList.add('is-visible');

        if( this.breakpoint.matches) {
            this.pauseTimeout = setTimeout(() => {
                this.pauseButton.classList.remove('is-visible');
            }, 2000);
        }
    }

    pauseVideo() {
        this.video.pause();
    }

    onPause() {
        clearTimeout(this.pauseTimeout);

        this.pauseButton.classList.remove('is-visible');
        if(!this.animating) {
            this.playButton.classList.add('is-visible');
        }
    }

    toggleModal() {
        if(this.modalOpen) {
            this.closeModal();
        } else {
            this.openModal();
        }
    }


    openModal() {
        this.modalOpen = true;

        if (this.animating) {
            return;
        }

        this.playVideo();

        const tl = gsap.timeline({
            onStart: () => {
                this.animating = true;

                this.openModalButton.classList.remove('is-visible');
            },
            onComplete: () => {
                this.animating = false;
                this.videoModal.classList.add('is-active');

                this.closeModalButton.classList.add('is-visible');
            },
        });

        tl.to(this.videoModal, {
            opacity: 1,
            ease: 'power2.inOut',
            duration: 0.8,
        });

        if (this.canHoverAndPoint.matches) {
            tl.to(this.videoModalInner, {
                scale: 0.8,
                ease: 'power2.inOut',
                duration: 1,
            }, 0);
        }
    }


    closeModal() {
        this.modalOpen = false;

        if (this.animating) {
            return;
        }

        const tl = gsap.timeline({
            onStart: () => {
                this.animating = true;
                this.pauseVideo();

                this.videoModal.classList.remove('is-active');
                this.openModalButton.classList.add('is-visible');

                this.closeModalButton.classList.remove('is-visible');
                this.pauseButton.classList.remove('is-visible');
                this.playButton.classList.remove('is-visible');
            },
            onComplete: () => {
                this.animating = false;
            },
        });

        tl.to(this.videoModal, {
            opacity: 0,
            ease: 'power2.inOut',
            duration: 0.8,
        });

        if (this.canHoverAndPoint.matches) {
            tl.to(this.videoModalInner, {
                scale: 1,
                ease: 'power2.inOut',
                duration: 0.8,
            }, 0);
        }
    }

    destroy() {
        document.removeEventListener('keydown', this.boundHandleKeys);
        this.resizeObserver.disconnect();

        this.closeModal();
    }
}